import { allModifiers, keywordAndModifierRegex, keywords } from "@quickpoint.me/shared";

const filterKeywordParser = function (code: string): string[] {
  const parseFor = ["filter:"];
  if (!code) {
    return [];
  }
  const parsed: string[] = [];
  const lines = code.split("\n");
  let content: string;

  lines.forEach((line: string) => {
    const keywordModifierMatch = line.match(keywordAndModifierRegex);
    if (keywordModifierMatch && keywordModifierMatch[2]) {
      const type = keywordModifierMatch[2];
      content = keywordModifierMatch[3 + keywords.length + allModifiers.length];
      content = content.replace(type, "");
      content = content.trim();

      if (parseFor.includes(type)) {
        parsed.push(content);
      }
    }
  });

  return parsed;
};

export default filterKeywordParser;
